const state = {
  agentWhatsappCampaigns: [],
};
export default state;
